module.exports = __webpack_public_path__ + "assets/img/open_3.0ceabb2b.png";